import { intl } from '../intl';

//Wrapper for react-intl that outputs a more terse form of intl.formatMessage as well the original
const useTranslations = () => {
  const t = (id, ...args) => intl.formatMessage({ id }, ...args)
  return [t, intl];
};

export default useTranslations;